<div class="kanban-column" [ngClass]="status">
  <h4 class="kanban-column__title">
    <span>{{ title | leadStatus }}</span>
    <mat-icon>expand_more</mat-icon>
  </h4>

  <div
    class="kanban-column__content"
    cdkDropList
    [id]="dropListId"
    [cdkDropListData]="leads"
    [cdkDropListConnectedTo]="connectedTo"
    (cdkDropListDropped)="drop($event)"
  >
    <app-kanban-card
      *ngFor="let lead of leads; trackBy: trackByLead"
      cdkDrag
      [cdkDragData]="lead"
      [lead]="lead"
    ></app-kanban-card>
  </div>
</div>
